import React, { Component, Fragment } from 'react';
import { Fade, Zoom } from 'react-reveal';
import { Col, Container, Row } from 'shards-react';
import { ReactComponent as Contact } from '../../../assets/img/homepage/contact.svg';
import { ReactComponent as Forms } from '../../../assets/img/homepage/form.svg';
import { ReactComponent as Progress } from '../../../assets/img/homepage/progress2.svg';
import { ReactComponent as LandingImage } from '../../../assets/img/typing.svg';
import LandingNavbar from '../../layout/Navbar/LandingNavbar';
import ContactForm from '../ContactPage/ContactForm';
import './Landing.scss';

class Landing extends Component {
  state = {
    navbarOpen: false,
  };
  handleNavbar = () => {
    this.setState({ navbarOpen: !this.state.navbarOpen });
  };
  render() {
    return (
      <Fragment>
        <LandingNavbar
          navbarState={this.state.navbarOpen}
          handleNavbar={this.handleNavbar}
        />

        <Container className=''>
          <Row className='landing align-items-center d-flex text-white'>
            <Col className='align-items-center' sm='12' lg='6'>
              <Fade>
                <h2 className='landing-bold'>Let your complaints be heard </h2>
                <h6 className='w-60'>
                  Frustrated with Company ___? <br />
                  Disappointed with the quality of your recent online purchase?
                </h6>
                <div className='home-buttons'>
                  <button
                    className='landing-button bg-white text-dark mb-3'
                    onClick={() => this.props.history.push('/register')}
                  >
                    Start Here
                  </button>
                  <button
                    className='landing-button bg-success mb-3'
                    onClick={() => this.props.history.push('/login')}
                  >
                    Login
                  </button>
                </div>
              </Fade>
            </Col>
            <Col className='align-items-center' sm='12' lg='6'>
              <Fade>
                <Contact className='forms-image' />
              </Fade>
            </Col>
          </Row>
          <Row className='p-5 align-items-center'>
            <Col className='' sm='12' lg='6'>
              <h2>New Complaint System</h2>
              <p>
                When you submit a new complaint, an email will be sent to you
                and our agents.
              </p>
              <p>
                The new enhanced complaint form will enable us to filter through
                and attend to you better.
              </p>

              <p>
                In case you do not have an account, we will create an account
                and please make sure you check your inbox for the login details
              </p>
            </Col>
            <Col className='6' sm='12' lg='6'>
              <Zoom>
                <div className='forms'>
                  <Forms className='forms-image' />
                </div>
              </Zoom>
            </Col>
          </Row>
          <Row className=' bg-dark1 p-5'>
            <Col className='text-center steps' sm='12' lg='6'>
              <h2 className='text-white'>How to use the new portal?</h2>
            </Col>
            <Col className='text-white steps'>
              <div>Step 1: Register an Account</div>
              <div> Step 2: Login to Dashboard</div>
              <div> Step 3: Add a Complaint</div>
              <div>
                Step 4: An agent would be assigned to the case. <br />
                <span className='caption text-white'>
                  Note: Agent assignment could lead up to 14 days due to high
                  volume of complaints.
                </span>
              </div>
              <div>Step 5: Agent will communicate with you through emails.</div>
              <div>
                Step 6: Agent will advise further actions or close the
                complaint.
              </div>
            </Col>
          </Row>
          <Row className='p-5 align-items-center '>
            <Col className='' sm='12' lg='6'>
              <Zoom>
                <div className='forms'>
                  <Progress className='forms-image' />
                </div>
              </Zoom>
            </Col>
            <Col className='' sm='12' lg='6'>
              <h2>Track the progress</h2>
              <p>
                Now you can login into your account and track the progress of
                the complaints
              </p>
            </Col>
          </Row>
          <Row className='p-md-2 p-2 p-xl-5 bg-sunshine align-items-center'>
            <Col className='p-md-3 p-lg-5 p-sm-3 ' sm='12' lg='6'>
              <h2 className=''>Contact Us</h2>
              <p className=''>
                Once the agent has been assigned, you can communicate with the
                agent to check on the progress and updates related to your
                complaint.
              </p>
            </Col>
            <Col className='p-lg-5 p-sm-1' sm='12' lg='6'>
              <Zoom>
                <div className='forms'>
                  <LandingImage className='forms-image' />
                </div>
              </Zoom>
            </Col>
          </Row>
        </Container>
        <div className='bg-black d-flex w-100 flex-row p-2'>
          <ul>
            <li>
              <a href='http://www.nccc.org.my/v2/index.php/home'>
                NCCC Website
              </a>
            </li>
            <li>
              <a href='http://www.nccc.org.my/v2/index.php/mengenai-nccc'>
                About Us
              </a>
            </li>
            <li>
              <a href='http://www.nccc.org.my/v2/index.php/contact-us'>
                Contact Details
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a href='http://www.nccc.org.my/v2/index.php/aduan-pengguna/arkib-2010'>
                Archives
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a href='http://www.nccc.org.my/v2/index.php/nccc-di-pentas-media/pentas-media-2013'>
                Press
              </a>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default Landing;
